import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import DataTable from "../../Components/DataTable/DataTable";
import { DatePicker, Message } from "@arco-design/web-react";
import { IconInfoCircle } from "@arco-design/web-react/icon";
import { ManageApis } from "../../AppServices/ManageApi";
import Loader from "../../Components/LoaderComponent/Loader";
import moment from "moment";
import { convertUtcToBrowserTimeZone, dataTableInitialLoader, getLocalStorage } from "../../Functions/Utils";
import { useStoreValues } from "../../Context/storeProvider";
import axios from "axios";

function ApiHits() {
    const { user_Roll } = useStoreValues()
    const InitialFilterValue = {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        Type: "All",
        accountList: ""


    };
    const [filterValues, setfilterValues] = useState(InitialFilterValue);
    const [accountList, setAccountList] = useState([]);
    const [apiHitData, setApiHitData] = useState()
    const [DateRangeValue, setDateRangeValue] = useState([
        moment().startOf("month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
    ]);
    const [filterResponse, setFilterResponse] = useState({});
    const [TableData, setTableDta] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [tableLoader, setTableLoader] = useState(false);
    const [pageSize, setpageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(1);

    const TableColumn = [
        {
            title: "End Point",
            dataIndex: "apiName",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: "Created Date",
            dataIndex: "createdDate",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            render: (v, record) => {
                // //console.log("Date string here --->", new Date(record.createdDate).toLocaleString())
                // ""
                //console.log("record values --->", record)
                return (<div>{convertUtcToBrowserTimeZone(record.createdDate)}</div>)
            }
        },
        {
            title: "Method",
            dataIndex: "method",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: "Type",
            dataIndex: "type",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
    ];

    useEffect(() => {
        GetTotalHitCount(
            filterValues?.Type,
            filterValues?.startDate,
            filterValues?.endDate,
            filterValues?.accountList
        );
        GetLogDetails(
            filterValues?.Type,
            filterValues?.startDate,
            filterValues?.endDate,
            filterValues?.accountList
        );
        getAccountList()
    }, []);
    // /api/AppLog/GetTotalCount?Type=All&UserId=7179c45a-f5a8-4b8a-a18b-9d0373197160
    const GetTotalHitCount = async (type = "", startDate = "", endDate = "", accountList = '') => {
        try {
            setIsLoading(true);
            const path = `${global.getTotalHitCount}?${accountList ? "AccountId=" + accountList + "&" : ""}${getLocalStorage("user_roll") !== "Admin" ? "UserId=" + getLocalStorage(
                "clientId"
            ) : ""}&startDate=${startDate}&endDate=${endDate}&Type=${type}`;
            let response = await ManageApis("post", path);

            if (response.message == "Success") {
                //console.log(response)
                setFilterResponse(response.response_data);

                setIsLoading(false);
            } else {
                //console.log(response);
                setIsLoading(false);
            }
        } catch (error) {
            //console.log(error);
            setIsLoading(false);
        }
    };
    // /api/AppLog/GetApiRequestLog?Type=All&UserId=7179c45a-f5a8-4b8a-a18b-9d0373197160
    const GetLogDetails = async (type = "", startDate = "", endDate = "", accountList = '') => {
        try {
            const path = `${global.GetAppLogDetails}?${accountList ? "AccountId=" + accountList + "&" : ""}${getLocalStorage("user_roll") !== "Admin" ? "UserId=" + getLocalStorage(
                "clientId"
            ) : ""}&startDate=${startDate}&endDate=${endDate}&Type=${type}`;
            let response = await ManageApis("post", path);
            setIsLoading(true);
            if (response.message == "Success") {
                //console.log(response.response_data);
                setTableDta(
                    response.response_data.map((itm) => ({
                        ...itm,
                        // createdDate: moment(itm.createdDate).format("YYYY-MM-DD"),
                    }))
                );
                setApiHitData(
                    response.response_data.map((itm) => ({
                        ...itm,
                        // createdDate: moment(itm.createdDate).format("YYYY-MM-DD"),
                    }))
                );

                setIsLoading(false);
            } else {
                //console.log(response);
                setIsLoading(false);
            }
        } catch (error) {
            //console.log(error);
        }
    };

    const handleSubmitFilter = () => {
        try {
            GetTotalHitCount(
                filterValues?.Type,
                filterValues?.startDate,
                filterValues?.endDate,
                filterValues?.accountList
            );
            GetLogDetails(
                filterValues?.Type,
                filterValues?.startDate,
                filterValues?.endDate,
                filterValues?.accountList

            );
        } catch (error) {
            //console.log(error);
        }
    };

    const handleDataRange = (event) => {
        if (event?.length) {
            setDateRangeValue(event);
            setfilterValues((pre) => ({
                ...pre,
                startDate: event[0],
                endDate: event[1],
            }));
        } else {
            setDateRangeValue([]);
            setfilterValues((pre) => ({ ...pre, startDate: "", endDate: "" }));
        }
    };

    const getAccountList = async () => {
        try {
            let param = `?UserId=${getLocalStorage("clientId")}`
            let response = await ManageApis("get", global.getAccountList + param);
            //console.log(response);

            if (response.message === "Success") {

                // const clientList = response?.response_data.map(row => ({
                //     name: row.accountName,
                //     id: row.id,
                // }));
                // ""
                if (response?.response_data.length == 1) {
                    setAccountList([...response?.response_data]);
                    GetTotalHitCount(
                        filterValues?.Type,
                        filterValues?.startDate,
                        filterValues?.endDate,
                        response?.response_data?.accountList
                    );
                    GetLogDetails(
                        filterValues?.Type,
                        filterValues?.startDate,
                        filterValues?.endDate,
                        response?.response_data?.accountList
                    );
                } else {

                    setAccountList([{ id: '', accountName: 'All' }, ...response?.response_data]);
                }
                // setloader1(false)

            } else {
                // setloader1(false)
                //console.log(response)
                Message.error(response?.message)
            }
        } catch (error) {
            //console.log(error);
        }
    };
    const handleReset = () => {
        try {
            setDateRangeValue([]);

            setfilterValues((pre) => ({ Type: "All", startDate: " ", endDate: " " }));

            GetTotalHitCount("All", "", "");
            GetLogDetails("All", "", "");
        } catch (error) {
            //console.log(error);
        }
    };
    function onChangeTable(pagination) {
        // //console.log(pagination);
        const { current, pageSize } = pagination;
        setTableLoader(true);
        setApiHitData(dataTableInitialLoader(TableColumn));

        setTimeout(() => {
            setApiHitData(TableData.slice((current - 1) * pageSize, current * pageSize));
            setcurrentPage(current);
            setpageSize(pageSize);
            setTableLoader(false);
        }, 2000);
    }

    const handleDownload = async () => {
        try {
            const params = {
                // clientid: currentClient,
                // serviceid: currentService,
                // startDate: sd,
                // endDate: ed,
            }
            //old base-api
            // const response = await axios.get('https://api-uat-demo.pixl.ai/api/Hit/GetSummaryReport', {
            //     responseType: 'arraybuffer',
            //     params
            // });

            // ""
            let type = filterValues.Type
            if (filterValues.Type == "All") {
            } else {

                type = filterValues.Type + " Card"
            }

            const path = `?${filterValues?.accountList ? "AccountId=" + filterValues?.accountList + "&" : ""}${getLocalStorage("user_roll") !== "Admin" ? "UserId=" + getLocalStorage(
                "clientId"
            ) : ""}&startDate=${filterValues?.startDate}&endDate=${filterValues?.endDate}&Type=${type}`;
            const response = await axios.get(global.uploadData + global.downloadApiLogs + path, {
                responseType: 'arraybuffer',
                headers: {
                    Authorization: "Bearer " + getLocalStorage("access_token"),
                },
            });
            if (response.status == 200) {
                const filename = "Downloadfile.xlsx"
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                // Create a download link and trigger a click event to start the download
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
            else {
                alert("Something Went Wrong")
            }
        } catch (error) {
            alert("Connectivity Issue. Please try again later")
        }
    }

    return (
        <>
            {isLoading && <Loader />}

            <div className="">
                <div className="admin_Section overflow-auto scrollbar1">
                    <div className="px-3">
                        <div className="mb-3">
                            <div className="d-flex justify-content-end">
                                <button className="mt-2 ms-0 ms-md-2 mt-md-0 btn px_btn btn-master-line px-3 py-2 rounded fw_500 font_12 " disabled={!TableData?.length} onClick={handleDownload}>Download</button>
                            </div>
                            <div className="row align-items-center">
                                <div className="col-12 col-lg-2 col-md-3 mb-3 mb-md-0">
                                    <h3 className="font_18 fw_600 mb-0 text-black py-2">
                                        API Logs
                                    </h3>
                                </div>
                                <div className="align-items-center col-12 col-xl-10">

                                    <div className="align-items-center d-flex flex-column flex-md-row gap-2">

                                        {user_Roll !== "Admin" &&

                                            <div className="d-flex flex-column w-100">
                                                <span className="font_14 fw_500 ws_nowrp d-none">
                                                    Client Name
                                                </span>
                                                <span className='font_14 fw_500 ws_nowrp'  >
                                                    Account
                                                </span>
                                                <select
                                                    className="form-control rounded font_14"
                                                    onChange={(e) =>
                                                        setfilterValues((pre) => ({ ...pre, accountList: e.target.value }))
                                                    }
                                                    value={filterValues.accountList}
                                                >
                                                    {accountList?.map((itm) => (<option value={itm?.id}>{itm.accountName}</option>))}
                                                </select>
                                            </div>
                                        }
                                        <div className="d-flex flex-column  w-100">
                                            <span className='font_14 fw_500 ws_nowrp'>
                                                Document Type
                                            </span>
                                            <select
                                                className="form-control rounded font_14"
                                                onChange={(e) =>
                                                    setfilterValues((pre) => ({ ...pre, Type: e.target.value }))
                                                }
                                                value={filterValues.Type}
                                            >
                                                <option value={"All"}>All</option>
                                                <option value={"Aadhar"}>Aadhaar Card</option>
                                                <option value={"Pan"}>Pan Card</option>
                                                <option value={"Pan360"}>Pan 360 verification</option>
                                            </select>
                                        </div>
                                        <div className="d-flex flex-column w-100">
                                            <span className='font_14 fw_500 ws_nowrp'  >
                                                Date
                                            </span>
                                            <div className="arco_rangepicker w-100">
                                                <DatePicker.RangePicker
                                                    allowClear
                                                    onClear={() => setDateRangeValue([])}
                                                    onChange={handleDataRange}
                                                    value={DateRangeValue}
                                                    style={{
                                                        width: "100%",
                                                        height: 40,
                                                        borderColor: "#eee",
                                                        backgroundColor: "transparent",
                                                    }}
                                                    prefix={<IconInfoCircle />}
                                                />
                                            </div>
                                        </div>
                                        <div className="d-flex flex-column w-100 flex-md-row mt-1 pt-3">
                                            <button
                                                className="btn px_btn btn-master px-4 py-2 rounded fw_500 font_12 w-100"
                                                onClick={handleSubmitFilter}
                                            >
                                                Filter
                                            </button>
                                            <button
                                                className="mt-2 ms-0 ms-md-2 mt-md-0 btn px_btn btn-master-line px-3 py-2 rounded fw_500 font_12 w-100"
                                                onClick={handleReset}
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                    {/* <div className="flex-fill">
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-4 mb-3">
                                <div className="align-items-center bd_master border-6 border-bottom box_width01 d-flex gap-2 justify-content-between p-3 rounded-3 shadow white_box">
                                    <h5 className="mb-0 text-black fw_600 font_16">Total API Hit Count</h5>
                                    <div className="min_h_50x min_w_50x align-items-center bd_master border border-7 d-flex font_14 font_600 justify-content-center mb-0 rounded-circle text-black sts_r1">
                                        {filterResponse?.totalCount || 0}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <div className="align-items-center bd_master border-6 border-bottom box_width01 d-flex gap-2 justify-content-between p-3 rounded-3 shadow white_box">
                                    <h5 className="mb-0 text-black fw_600 font_16">Aadhar Card  API Hit Count</h5>
                                    <div className=" min_h_50x min_w_50x align-items-center bd_master border border-7 d-flex font_14 font_600 justify-content-center mb-0 rounded-pill text-black sts_r1">
                                        {filterResponse?.aadharcount || 0}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <div className="align-items-center bd_master border-6 border-bottom box_width01 d-flex gap-2 justify-content-between p-3 rounded-3 shadow white_box">
                                    <h5 className="mb-0 text-black fw_600 font_16">PAN Card API Hit Count </h5>
                                    <div className="min_h_50x min_w_50x align-items-center bd_master border border-7 d-flex font_14 font_600 justify-content-center mb-0 rounded-pill text-black sts_r1">
                                        {filterResponse?.pancount || 0}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="overflow-auto  scrollbar1">
                            <DataTable
                                columnData={TableColumn}
                                rowData={TableData}
                                onChangeTable={onChangeTable}
                                current={currentPage}
                                pageSize={pageSize}
                                total={TableData?.length}
                                loading={tableLoader}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ApiHits;

